import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useAppContext } from "../../../_context";
import Founder from "./Founder";

const Founders = () => {
  const [{ tx }] = useAppContext();
  return (
    <section className="section-padding-top">
      <Container>
        <Row>
          <Col md={10} className="text-center m-auto">
            <h2>{tx["Meet Robert & Bogdan"]}</h2>
            <p className="text-grey-1">{tx["aka “The Papas of RacketPal”"]}</p>
          </Col>
        </Row>
        <Row>
          <Col md={10} className="m-auto">
            <Founder founder={"Robert Rizea"} image="/img/about/robert.jpg">
              <p>
                {
                  tx[
                    "Robert and Bogdan are the two co-founders who gave birth to RacketPal. But they haven’t always been startup entrepreneurs. At the age of 7, Robert started passion for tennis in his hometown Bucharest, Romania, where he first picked up a racket."
                  ]
                }
              </p>
              <p>
                {
                  tx[
                    "Fast forward 20 years and after a move to the US for his undergraduate studies, Robert relocated to London where he started his career in digital marketing and met Bogdan."
                  ]
                }
              </p>
            </Founder>
          </Col>
        </Row>
        <Row>
          <Col md={10} className="m-auto">
            <Founder
              founder={"Bogdan Demeny"}
              image="/img/about/bogdan.jpg"
              flipped={true}>
              <p>
                {
                  tx[
                    "Bogdan's story on the other hand is different. The tech guru behind RacketPal started playing squash more often after he moved to London in 2015, but sport was always part of his youth. When he was younger Bogdan was a football referee in his spare time, while he focused on coding full time."
                  ]
                }
              </p>
              <p>
                {
                  tx[
                    "When Robert the marketeer met Bogdan the developer, they both shared one thing in common: racket sports. And it was only a matter of time before the two got talking, and the RacketPal journey began..."
                  ]
                }
              </p>
            </Founder>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Founders;
